import { PageName } from "constants/Pages";
import { Post } from "./types";

type PostIdentifierCarrier = Partial<
  Pick<Post, "_id" | "id" | "postClusterId">
>;

export function getPostIdentifierKind(post?: PostIdentifierCarrier | null) {
  if (post?._id) {
    return "_id" as const;
  }

  if (post?.id) {
    return "id" as const;
  }

  return "none" as const;
}

export function getEditPostOpenTelemetryMetadata({
  post,
  page,
  source,
}: {
  post: Partial<Post> | undefined;
  page: PageName;
  source: string;
}) {
  const postIdKind = getPostIdentifierKind(post);

  return {
    source,
    page: page.toLowerCase(),
    post_identifier: post?._id || post?.id,
    post_id_kind: postIdKind,
    post_id_present: postIdKind !== "none",
    post_cluster_id: post?.postClusterId,
    post_cluster_id_present: Boolean(post?.postClusterId),
    is_success: Boolean(post?.isSuccess),
    is_queued: Boolean(post?.queued),
    account_ids_count: Array.isArray(post?.accountIds)
      ? post.accountIds.length
      : post?.accountId
        ? 1
        : 0,
  };
}

export function getMissingIdentifierTelemetryMetadata({
  errorMessage,
  formPost,
  requestedPost,
  requestType,
}: {
  errorMessage: string;
  formPost: Partial<Post> | undefined;
  requestedPost: Partial<Post> | undefined;
  requestType: string | undefined;
}) {
  return {
    error_message: errorMessage,
    request_type: requestType,
    current_post_identifier: formPost?._id || formPost?.id,
    current_post_id_kind: getPostIdentifierKind(formPost),
    requested_post_identifier: requestedPost?._id || requestedPost?.id,
    requested_post_id_kind: getPostIdentifierKind(requestedPost),
    requested_post_cluster_id: requestedPost?.postClusterId,
    requested_post_cluster_id_present: Boolean(requestedPost?.postClusterId),
    current_account_ids_count: Array.isArray(formPost?.accountIds)
      ? formPost.accountIds.length
      : formPost?.accountId
        ? 1
        : 0,
    requested_account_ids_count: Array.isArray(requestedPost?.accountIds)
      ? requestedPost.accountIds.length
      : requestedPost?.accountId
        ? 1
        : 0,
  };
}
